import {
  Component, Input, HostBinding, EventEmitter, Output, OnInit, OnDestroy, ChangeDetectorRef,
} from '@angular/core';

import * as _ from 'lodash';

import { RightPanelService } from './right-panel.service';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'right-panel',
  templateUrl: 'right-panel.component.html',
  styleUrls: ['right-panel.component.scss'],
})
export class RightPanelComponent implements OnInit, OnDestroy {
  @HostBinding('class.fixed')
  @Input() fixed: boolean = true;

  @HostBinding('class.moved-out')
  @Input() movedOut: boolean = false;

  @HostBinding('class.version2')
  @Input() isVersion2: boolean = false;

  @Input() showToggleButton: boolean = true;

  @Output() movedOutChange = new EventEmitter<boolean>();

  isActive: boolean = true;

  constructor(
    private rightPanelService: RightPanelService,
    private ref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.rightPanelService.togglePanel
    .pipe(takeWhile(() => this.isActive))
    .subscribe((toggle?: boolean) => {
      this.togglePanel(toggle);
    });
  }

  ngOnDestroy() {
    this.isActive = false;
  }

  public togglePanel(toggle?: boolean): void {
    if (_.isNil(toggle)) {
      this.movedOut = !this.movedOut;
    } else {
      this.movedOut = toggle;
    }
    this.ref.markForCheck();
    this.movedOutChange.emit(this.movedOut);
  }

  onToggleButtonClick() {
    this.togglePanel();
  }
}
